import React from 'react';
import { Container, Row, Col, Card, ListGroup, Image } from 'react-bootstrap';
import Header from './Header';
import Footer from './Footer';
import RecentPost from './RecentPost';

const DomainSetup = () => {
  return (
    <>
    <Header />
    <div className="full-div" id="blog">
    <Container fluid className="main-sec">
      <Row>
        <Col sm={2}></Col>
        <Col sm={7} className="bg-white p-4 div-shadow mb-3">
          <h1 className="head-color">Mastering Domain Setup in cPanel: Quick and Easy Steps</h1>
          <span className="small ms-2"><b>Publish By:-</b> CodeInputs</span>
          
          <Row className="mt-3 text-center">
            <Col md={12}>
              <Image src="/graphics/images/domain.webp" alt="domain" fluid />
            </Col>
          </Row>

          <p className="mt-4 blacktext">In this blog, we provide a comprehensive guide to setting up domains on your cPanel server with ease. Whether you're adding a new domain, configuring DNS settings, or managing multiple domains, this tutorial walks you through every step. You'll learn how to efficiently add and organize domains, customize settings, and troubleshoot common issues, making it simple to streamline your domain management in cPanel. Perfect for beginners and seasoned users alike, this guide will help you confidently handle domain setup on your cPanel server.</p><br/>

          <h4>What is a Domain?</h4>
          <p className="mt-4 blacktext">A domain is essentially the address of a website on the internet, allowing people to find and access it easily. It’s the part of a URL (web address) that comes after "www." or "http://" – like example.com in the URL https://www.example.com.</p>
          <p className="mt-4 blacktext">Domains are divided into two main parts:</p>

          <ol>
            <li><b>Top-Level Domain (TLD)</b>: This is the ending of the domain, such as .com, .org, .net, .edu, etc.</li>
            <li><b>Second-Level Domain</b>: This is the unique part chosen by the website owner, like example in example.com.</li>
          </ol>

          <p className="mt-4 blacktext">In short, a domain is the easy-to-remember name used to locate and access websites, helping connect users with information online.</p>

          <Row className="mt-3">
            <Col md={12}>
              <Image src="/graphics/images/domains.webp" alt="domains" fluid />
            </Col>
          </Row>

          <h4>Step-by-Step Guide:</h4>
          <h5>Step 1: Log into cPanel</h5>
          <ol>
                  <li class="blacktext fw-normal mb-3">Access your cPanel account by entering your domain followed by “/cpanel” (e.g., yourdomain.com/cpanel) in the browser.</li>

                  <li class="blacktext fw-normal mb-3">Enter your username and password to log in.</li>
          </ol>


          <h5>Step 2: Add the Domain</h5>
          <ol>
                  <li class="blacktext fw-normal mb-3">In the <b>Domains</b> section, click on <b>Domains</b> or <b>Addon Domains</b> depending on your cPanel version.</li>

                  <img class="img-responsive" src="/images/domain_section.webp" width="100%" alt="domain section"/>

                  <li class="blacktext fw-normal mb-3">If you’re adding a new domain click <b>Create a New Domain</b> button.</li>

                  <img class="img-responsive" src="/images/create_domain.webp" width="100%" alt="create domain"/>

                  <li class="blacktext fw-normal">Fill in the <b>New Domain Name</b> field with the domain you want to add.</li>

                  <img class="img-responsive" src="/images/domain_form.webp" width="100%" alt="backup"/>

                  <li class="blacktext fw-normal">After entering the domain name, the <b>Subdomain</b> and <b>Document Root</b> fields will populate automatically. Adjust these if needed.</li>

                  <li class="blacktext fw-normal">Click <b>Add Domain</b> to save the domain.</li>
                </ol>


          <h5>Step 3: Configure Domain Settings</h5>
          <ol>
                  <li class="blacktext fw-normal">Once the domain is added, configure any settings specific to this domain, such as email accounts, SSL certificates, or redirects.</li>

                  <img class="img-responsive" src="/images/manage_setting.webp" width="100%" alt="manage setting"/>

                  <li class="blacktext fw-normal">Go to <b>Zone Editor</b> if you need to manage DNS records.</li>

                  <img class="img-responsive" src="/images/zone.webp" width="100%" alt="zone"/>
                </ol>

          <h5>Step 4: Link to Hosting</h5>
          <ol>
                  <li class="blacktext fw-normal">Point your domain’s DNS to the hosting provider’s nameservers where cPanel is hosted.</li>

                  <li class="blacktext fw-normal">After updating DNS, it may take some time (up to 48 hours) for changes to propagate.</li>
                </ol>


          <p class="mt-4 orgspan fw-bold">Additional Notes</p>
                <ul><li class="blacktext fw-normal">
                  <b>Addon Domains</b> allow you to host multiple sites on the same hosting account.
                </li>
                <li class="blacktext fw-normal">You can manage all domains in the <b>Domains</b> section.</li></ul>

                <p class="mt-4 blacktext fw-normal">Now your new domain should be added and ready for use within cPanel!</p>
              

          <Row className="mt-3">
            <Col md={12}>
              <Image src="/graphics/images/list_domain.webp" alt="list domain" fluid />
            </Col>
          </Row>

          <iframe
            className="mt-4"
            width="100%"
            height="315"
            src="https://www.youtube.com/embed/uJQzHHvycxY"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </Col>
        <Col sm={3} className="recent-post">
          <Card className="bg-white p-4 mb-3 div-shadow">
            <h4 className="head-color mt-4">Recent Post</h4>
            <RecentPost/>
          </Card>

          <Card className="bg-white p-4 div-shadow">
            <h4 className="mt-4 head-color">Recent Comment</h4>
            <p style={{ color: "#85929e" }}>No Comments to Show</p>
          </Card>
        </Col>
      </Row>
    </Container>
    </div>
    <Footer />
    </>
  );
};

export default DomainSetup;